module.exports = __webpack_public_path__ + "static/img/banner.15c66004.png";